import React, { useMemo } from 'react';
import axios from 'axios';
import config from '../../../../config';
import TransferList from '../shared/TransferList';

/**
 * Delivery-partner assignment for the current concessionaire.
 * Thin adapter over the generic <TransferList/>.
 */
const DeliveryPartnerAdd = () => {
    const adapter = useMemo(() => {
        const concessionaire_id = localStorage.getItem('concessionaireId');
        const login_id = localStorage.getItem('loginId');
        const headers = { Authorization: `${localStorage.getItem('sessiontoken')}` };

        return {
            loadCatalog: async () => {
                try {
                    const res = await axios.get(`${config.hostname}/deliverypartner/getalldeliverypartners`, { headers });
                    return (res.data || []).map((p) => ({ id: p._id, label: p.delivery_partner_name }));
                } catch (err) {
                    if (err?.response?.status === 404) return [];
                    throw err;
                }
            },
            loadAssigned: async () => {
                try {
                    const res = await axios.post(
                        `${config.hostname}/concessionairedeliverypartner/getdeliverypartner`,
                        { concessionaire_id },
                        { headers },
                    );
                    // Backend 404s (not empty array) when none are assigned.
                    return (res.data || [])
                        .filter((p) => p.delivery_partner_id)
                        .map((p) => ({
                            id: p.delivery_partner_id._id,
                            label: p.delivery_partner_id.delivery_partner_name,
                        }));
                } catch (err) {
                    if (err?.response?.status === 404) return [];
                    throw err;
                }
            },
            assign: (items) =>
                axios.post(
                    `${config.hostname}/concessionairedeliverypartner/createdeliverypartner`,
                    { concessionaire_id, delivery_partner_id: items.map((i) => i.id), login_id },
                    { headers },
                ),
            unassign: (ids) =>
                axios({
                    method: 'delete',
                    url: `${config.hostname}/concessionairedeliverypartner/removedeliverypartner`,
                    data: { concessionaire_id, delivery_partner_id: ids, login_id },
                    headers,
                }),
        };
    }, []);

    return (
        <TransferList
            adapter={adapter}
            availableTitle="Available delivery partners"
            assignedTitle="Assigned delivery partners"
            searchPlaceholder="Search delivery partners…"
        />
    );
};

export default DeliveryPartnerAdd;
